import React, { useState, createContext, useEffect } from 'react';
import { API } from 'aws-amplify';
import { useAuth } from './Auth';
import { FreezePeriodApiInterface } from '../models/FreezePeriodInterface';
import { useApiError } from './ApiErrorProvider';
import { error } from '../constants/bindings';
import { useProfile } from './Profile';

const frezzePeriodDefaut = {
  pairingFreeze: [],
  flyingSchedule: [],
  sdoSubmission: [],
  simSubmission: [],
  artSubmission: []
} as FreezePeriodApiInterface;
const FreezePeriodContext = createContext({
  loading: true,
  freezePeriodData: frezzePeriodDefaut,
  getFreezePeriod: () => {}
});

export const FreezePeriodProvider = (props) => {
  const { user } = useAuth();
  const profileContext = useProfile();
  const { setErrorCode } = useApiError();
  const [freezePeriodData, setFreezePeriodData] = useState(
    frezzePeriodDefaut as FreezePeriodApiInterface
  );
  const [loading, setLoading] = useState(true as boolean);

  useEffect(() => {
    if (!user) {
      return;
    }
    if (profileContext?.profile?.results) {
      getFreezePeriod();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, profileContext.profile.results]);

  const getFreezePeriod = async () => {
    if (!user) {
      return;
    }
    setLoading(true);
    try {
      const freezePeriodData = await API.get(
        'crewlife',
        `/freezeperiod/retrieve`,
        {}
      );
      setFreezePeriodData(freezePeriodData);
      setLoading(false);
    } catch (e: any) {
      if (e.response?.status) {
        setErrorCode(e.response?.status);
      } else {
        setErrorCode(error.DEFAULT);
      }
      setLoading(false);
    }
  };

  return (
    <FreezePeriodContext.Provider
      value={{ loading, freezePeriodData, getFreezePeriod }}
    >
      {props.children}
    </FreezePeriodContext.Provider>
  );
};

export const useFreezePeriod = () => {
  const context = React.useContext(FreezePeriodContext);
  return context;
};
